import { useMutation } from '@apollo/client';

import {
  BulkUpdateContractLineInvoiceToCustomer,
  BulkUpdateContractLineInvoiceToCustomerVariables
} from '@/graphql/contracts/_generated_/bulkUpdateContractLineInvoiceToCustomer.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import BulkUpdateContractLineInvoiceToCustomerMutation
  from '@/graphql/contracts/bulkUpdateContractLineInvoiceToCustomer.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import {
  ALL_ITEMS
} from '@/config/common.config';

const getContractLineRefetchQuery = (contractId: UUID, isVariable: boolean) => {

  if (isVariable) {
    return {
      query: GetPaginatedFilteredVariableContractLinesQuery,
      variables: {
        filter: { headerPrimaryKey: { eq: contractId } },
        first: ALL_ITEMS
      }
    };
  }

  return {
    query: GetBCContractLinesQuery,
    variables:
    {
      filter: {
        contractId: { eq: contractId }
      },
      first: ALL_ITEMS
    }
  };
};

export function useBulkUpdateContractLineInvoiceToCustomer(contractId: UUID) {
  const [_bulkUpdateContractLineInvoiceToCustomer, { loading }] =
    useMutation<BulkUpdateContractLineInvoiceToCustomer, BulkUpdateContractLineInvoiceToCustomerVariables>(
      BulkUpdateContractLineInvoiceToCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      },
    );

  const bulkUpdateContractLineInvoiceToCustomer = async (params: BulkUpdateContractLineInvoiceToCustomerVariables,
    isVariable: boolean, shouldRefetchCls: boolean) => {

    const refetchQueries = shouldRefetchCls ? [
      getContractLineRefetchQuery(contractId, isVariable)
    ] : [];


    const result = await _bulkUpdateContractLineInvoiceToCustomer({
      variables: {
        ...params,
      },
      awaitRefetchQueries: true,
      refetchQueries: refetchQueries
    });

    return result?.data?.bulkUpdateContractLineInvoiceToCustomer;
  };

  return {
    bulkUpdateContractLineInvoiceToCustomer,
    bulkUpdateContractLineInvoiceToCustomerLoading: loading
  };
}
